import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import ForgotPassword from "./Pages/Login/ForgotPassword";
import UpdatePassword from "./Pages/Login/UpdatePassword";
import PublicOnlyRoute from "./Components/PublicOnlyRoute";
import ProtectedRoute from "./Components/ProtectedRoute";
import DashboardLayout from "./Pages/Dashboard/DashboardLayout";
import Resumen from "./Pages/Dashboard/Resumen";
import Facturas from "./Pages/Dashboard/Facturas";
import Exportar from "./Pages/Dashboard/Exportar";
import Arca from "./Pages/Dashboard/Arca";
import Team from "./Pages/Dashboard/Team";
import Cuentas from "./Pages/Dashboard/Cuentas";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* --- Rutas Públicas (Cualquiera puede ver) --- */}
        <Route path="/" element={<Home />} />

        {/* --- Rutas Públicas Restringidas (Solo si NO estás logueado) --- */}
        <Route
          path="/login"
          element={
            <PublicOnlyRoute>
              <Login />
            </PublicOnlyRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicOnlyRoute>
              <Register />
            </PublicOnlyRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicOnlyRoute>
              <ForgotPassword />
            </PublicOnlyRoute>
          }
        />

        {/* --- Rutas Protegidas (Solo si SÍ estás logueado) --- */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Resumen />} />
          <Route path="facturas" element={<Facturas />} />
          <Route path="exportar" element={<Exportar />} />
          <Route path="arca" element={<Arca />} />
          <Route path="team" element={<Team />} />
          <Route path="cuentas" element={<Cuentas />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

        <Route
          path="/update-password"
          element={<ProtectedRoute><UpdatePassword /></ProtectedRoute>}
        />

        {/* ...otras rutas protegidas como /perfil, /configuracion, etc. */}

      </Routes>
    </BrowserRouter>
  );
}
